import { render } from "./CreditRequestLocalization.vue?vue&type=template&id=5e402a88"
import script from "./CreditRequestLocalization.vue?vue&type=script&lang=js"
export * from "./CreditRequestLocalization.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__